export default __webpack_public_path__ + "static/media/logoBadge.dd48155a.svg";